import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./formulario.css";
import FacebookLogin from "react-facebook-login";
import GoogleLogin from "react-google-login";
import { withTranslation } from "react-i18next";
import i18n from "../i18n";
import queryString from "query-string";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import isEmail from "validator/es/lib/isEmail";
import { withRouter, Link } from "react-router-dom";
import AlertDialog from "./AlertDialog";
class Formulario extends React.Component {
  constructor(props) {
    super(props);
    this.alertDialogRef = React.createRef();

    const googleUser = JSON.parse(localStorage.getItem("googleUser"));
    const facebookUser = JSON.parse(localStorage.getItem("facebookUser"));
    const user = JSON.parse(localStorage.getItem("user"));
    const acepto = JSON.parse(localStorage.getItem("acepto"));
    const enlace = JSON.parse(localStorage.getItem("enlace"));
    const local = JSON.parse(localStorage.getItem("id"));

    this.values = queryString.parse(this.props.location.search);

    if (this.props.id !== local) {
      localStorage.clear();
    }
    if (googleUser || facebookUser || user) {
      if (!acepto && enlace) {
        this.redireccion();
      }
      if (acepto && enlace) {
        window.location.href = enlace;
      }
    }

    this.state = {
      checkCondiciones: false,
      name: "",
      email: "",
      errorCondiciones: false,
      errorEmail: false,
      errorEmailNoValido: false,
      errorNombreNoValido: false
    };

    this.selectIdioma = this.selectIdioma.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.resetErrores = this.resetErrores.bind(this);
  }

  componentDidMount() {
    if (this.values.param && this.props.logo) {
      this.getUrlWebchat(this.values.param);
    }
  }

  redireccion = () => {
    this.props.history.push("/" + this.props.id + "/acepta");
  };

  resetErrores = () => {
    this.setState({
      errorCondiciones: false,
      errorEmail: false,
      errorEmailNoValido: false,
      errorNombreNoValido: false
    });
  };

  handleChange = event => {
    const { state } = this.state;
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState({ ...state, [event.target.name]: value });
  };

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.name === "") {
      this.setState({ errorNombreNoValido: true }, () => {
        this.alertDialogRef.current.handleClickOpen();
      });
    } else if (isEmail(this.state.email)) {
      this.realizarPeticion();
    } else {
      this.setState({ errorEmailNoValido: true }, () => {
        this.alertDialogRef.current.handleClickOpen();
      });
      console.log("correo no valido");
    }
  }

  responseFacebook = response => {
    if (!response.email) {
      this.setState({ errorEmail: true }, () => {
        this.alertDialogRef.current.handleClickOpen();
      });
      return;
    }
    this.setState(
      {
        facebookUser: {
          name: response.name,
          email: response.email,
          firstName: response.first_name,
          lastName: response.last_name
        }
      },
      () => {
        this.realizarPeticion();
      }
    );
  };

  responseGoogle = response => {
    if (!response.profileObj.email) {
      this.setState({ errorEmail: true }, () => {
        this.alertDialogRef.current.handleClickOpen();
      });
      return;
    }
    this.setState(
      {
        googleUser: {
          name: response.profileObj.name,
          firstName: response.profileObj.givenName,
          lastName: response.profileObj.familyName,
          email: response.profileObj.email
        }
      },
      () => {
        this.realizarPeticion();
      }
    );
  };

  responseGoogleError = response => {
    console.log(response);
  };

  responseFacebookError = response => {
    console.log(response);
  };

  changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  selectIdioma = event => {
    i18n.changeLanguage(event.target.value);
  };

  async getUrlWebchat(value) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify({
        param1: this.props.id,
        param2: value
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    };
    const response = await fetch("/api/urlWebchat", requestOptions);
    const result = await response.json();
    if (result.url) {
      const newWindow = window.open(result.url, "_self");
      if (newWindow) newWindow.opener = null;
    }
  }

  realizarPeticion = () => {
    const { local, googleUser, facebookUser, checkCondiciones, name, email } =
      this.state;

    if (local) {
      localStorage.setItem("local", JSON.stringify(this.props.hotel));
    }

    if (googleUser) {
      localStorage.setItem("googleUser", JSON.stringify(googleUser));
    }
    if (facebookUser) {
      localStorage.setItem("facebookUser", JSON.stringify(facebookUser));
    }
    if (name && email) {
      localStorage.setItem("user", JSON.stringify({ name, email }));
    }

    if (!checkCondiciones) {
      this.setState({ errorCondiciones: true }, () => {
        this.alertDialogRef.current.handleClickOpen();
      });
      return;
    }
    const requestOptions = {
      method: "POST",
      body: JSON.stringify({
        googleUser,
        facebookUser,
        establecimiento: this.props.id,
        plataforma: this.props.plataforma,
        usuario: { name, email },
        locale: navigator.language || navigator.userLanguage
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    };
    fetch("/apiLogin/" + this.props.plataforma + "/login", requestOptions)
      .then(response => {
        return response.text();
      })
      .then(data => {
        const json = JSON.parse(data);
        if (json.enlace) {
          localStorage.setItem("enlace", JSON.stringify(json.enlace));
        }
        if (json.aceptaComunicados) {
          localStorage.setItem("acepto", true);
        } else {
          localStorage.setItem("acepto", false);
          this.redireccion();
          return null;
        }
        if (json.enlace && !json.nuevo && json.aceptaComunicados) {
          window.location.href = json.enlace;
          return null;
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  render() {
    const { t } = this.props;
    const {
      checkCondiciones,
      name,
      email,
      errorCondiciones,
      errorEmail,
      errorEmailNoValido,
      errorNombreNoValido
    } = this.state;
    return (
      <div className="login-form">
        <div className="dropdown select-idioma">
          <button className="dropbtn">{t("idioma.label")}</button>
          <div className="dropdown-content">
            <button
              className="botones-idiomas"
              value={"es"}
              onClick={this.selectIdioma}
            >
              {t("es.label")}
            </button>
            <button
              className="botones-idiomas"
              value={"en"}
              onClick={this.selectIdioma}
            >
              {t("en.label")}
            </button>
          </div>
        </div>
        <div className="clear"></div>

        <form onSubmit={this.handleSubmit} noValidate>
          {this.props.logo && (
            <img
              className="logo"
              src={
                `https://imageswfz.s3-eu-west-1.amazonaws.com/login/` +
                this.props.logo
              }
              alt="Logo"
            />
          )}
          <h4 className="modal-title">{t("necesitasAyuda.label")}</h4>

          <FacebookLogin
            appId="739674833280846"
            callback={this.responseFacebook}
            onFailure={this.responseFacebookError}
            isDisabled={!checkCondiciones}
            icon="fa-facebook"
            fields="name,email,picture,first_name,last_name"
            textButton={t("facebook.label")}
            cssClass="botones-sociales facebook"
          />
          <GoogleLogin
            clientId="769334296338-op3r9r5b5t21gqaeg0jd61uugana3u7l.apps.googleusercontent.com"
            buttonText={t("google.label")}
            onSuccess={this.responseGoogle}
            onFailure={this.responseGoogleError}
            disabled={!checkCondiciones}
            isSignedIn={false}
            className="botones-sociales google"
            cookiePolicy={"single_host_origin"}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={checkCondiciones}
                onChange={this.handleChange}
                name="checkCondiciones"
                color="primary"
              />
            }
            className="texto-condiciones"
            label={
              <div>
                {t("acepto.label")}
                <Link
                  className="link-condiciones"
                  to={this.props.id + "/condiciones"}
                  target="_blank"
                >
                  {t("condiciones.label")}
                </Link>
                {t("y.label")}
                <Link
                  className="link-condiciones"
                  to={this.props.id + "/politica"}
                  target="_blank"
                >
                  {t("politica.label")}
                </Link>
              </div>
            }
          />
          <FormHelperText className="Mui-error mensaje-error">
            {errorEmail ? t("sinEmail.label") : ""}
          </FormHelperText>
          <AlertDialog
            resetErrores={this.resetErrores}
            ref={this.alertDialogRef}
            aviso={t("aviso.label")}
            aceptar={t("aceptar.label")}
            mensaje={
              errorEmail
                ? t("sinEmail.label")
                : errorEmailNoValido
                ? t("emailNoValido.label")
                : errorNombreNoValido
                ? t("nombreNoValido.label")
                : errorCondiciones
                ? t("condicionesObligatorias.label")
                : ""
            }
          />
          <div className="form-group formulario">
            <h4 className="modal-title">{t("o.label")}</h4>
            <input
              name="name"
              type="text"
              className="form-control"
              placeholder={t("nombre.label")}
              required="required"
              onChange={this.handleChange}
              value={name}
            />
          </div>
          <div className="form-group">
            <input
              name="email"
              type="email"
              className="form-control"
              placeholder={t("email.label")}
              required="required"
              onChange={this.handleChange}
              value={email}
            />
          </div>
          <FormControlLabel
            control={
              <Checkbox
                checked={checkCondiciones}
                onChange={this.handleChange}
                name="checkCondiciones"
                color="primary"
                label={t("condiciones.label")}
              />
            }
            className="texto-condiciones"
            label={
              <div>
                {t("acepto.label")}
                <Link
                  className="link-condiciones"
                  to={this.props.id + "/condiciones"}
                  target="_blank"
                >
                  {t("condiciones.label")}
                </Link>
                {t("y.label")}
                <Link
                  className="link-condiciones"
                  to={this.props.id + "/politica"}
                  target="_blank"
                >
                  {t("politica.label")}
                </Link>
              </div>
            }
          />
          <FormHelperText className="Mui-error mensaje-error">
            {errorCondiciones ? t("condicionesObligatorias.label") : ""}
          </FormHelperText>
          <input
            type="submit"
            disabled={!checkCondiciones}
            className="btn btn-primary btn-block btn-lg texto-boton"
            value={t("accede.label")}
          />
        </form>
      </div>
    );
  }
}

export default withTranslation()(withRouter(Formulario));
